<template>
  <div class="users">
    <router-view class="users__wrapper" />
    <Progress />
  </div>
</template>

<script>
import Progress from '@/components/Users/Education/Progress'

export default {
  name: 'userIndex',
  components: { Progress }
}
</script>

<style scoped lang="scss">
.users {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__wrapper {
    flex: 1;
  }
}
</style>
